export const UPDATE_COMPUTATION_DOCUMENT = "UPDATE_COMPUTATION_DOCUMENT"
export const SET_TAB_INDEX_COMPUTATION = "SET_TAB_INDEX_COMPUTATION"